<template>
  <v-container>
    <v-row>
      <v-col md="12">
        <v-img src="@/static/images/organization/cover.jpg" height="200">
          <v-row class="fill-height" align="end" justify="center">
            <v-col md="12">
              <div class="text-right">
                <v-chip
                  label
                  color="blue"
                  text-color="white"
                  class="font-weight-bold"
                >
                  <v-icon left v-text="$getIcon('mdiLabel')" color="white">
                  </v-icon>
                  NEGOTIATING
                </v-chip>
                <v-chip color="red" label text-color="white">
                  <v-icon left v-text="$getIcon('mdiStar')" color="white">
                  </v-icon>
                  HIGH
                </v-chip>
              </div>
            </v-col>
            <v-col md="12">
              <v-avatar class="d-inline-block mx-3 mb-2" size="120">
                <v-img
                  src="@/static/images/organization/default-logo.jpg"
                  contain
                ></v-img>
              </v-avatar>
              <div class="mx-1 white--text d-inline-block">
                <h1 class="client-heading">
                  {{ clientDetail.name }}
                </h1>
                <h2 class="client-heading">
                  {{
                    clientDetail.abbreviation
                      ? `(${clientDetail.abbreviation})`
                      : ""
                  }}
                </h2>
              </div>
            </v-col>
          </v-row>
        </v-img>
        <v-card class="elevation-5 mt-1">
          <v-tabs
            v-model="active"
            class="mx-0"
            color="grey darken-4"
            slider-color="grey"
          >
            <v-tab
              v-for="(tab, index) in tabOptions"
              :key="index + `tabHeadings`"
              class="text-capitalize"
              @click="activeTab = tab.name"
            >
              <v-icon class="mr-2 subheading" v-text="tab.icon"></v-icon>
              {{ tab.name }}
            </v-tab>
            <v-tab-item
              v-for="(tab, index) in tabOptions"
              :key="index + `tabItems`"
            >
              <component
                :is="tab.component"
                v-if="tab.name === activeTab"
                :client-detail="clientDetail"
                @clientFormResponse="formSuccess($event)"
                view-only
              ></component>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ClientOverview from "@/components/crm/client/client_detail/ClientOverview";
import ClientContactPersons from "@/components/crm/client/client_detail/ClientContactPersons";
import ClientBranch from "@/components/crm/client/client_detail/ClientBranch";
import ClientCommunicationLogs from "@/components/crm/client/client_detail/ClientCommunicationLogs";

export default {
  components: {
    ClientOverview,
    ClientContactPersons,
    ClientBranch,
    ClientCommunicationLogs
  },
  props: {
    clientDetail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeTab: "Overview",
      active: null,
      clientEndPoint: "/api/v1/crm/clients/",
      tabOptions: [
        {
          name: "Overview",
          component: "ClientOverview",
          icon: this.$getIcon("mdiEarth")
        },
        {
          name: "Contact Persons",
          component: "ClientContactPersons",
          icon: this.$getIcon("mdiAccountCircle")
        },
        {
          name: "Branches",
          component: "ClientBranch",
          icon: this.$getIcon("mdiNearMe")
        },
        {
          name: "Communication Logs",
          component: "ClientCommunicationLogs",
          icon: this.$getIcon("mdiHistory")
        }
      ]
    };
  },
  methods: {
    formSuccess(data) {
      this.fetchClientDetailData(data.slug);
    },
    fetchClientDetailData(clientSlug) {
      this.$axios.$get(`${this.clientEndPoint}${clientSlug}`).then(response => {
        this.clientDetail = response;
        this.client = this.clientDetail.slug;
      });
    }
  }
};
</script>
